var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-list';
                    var viewUrl = 'sprite.svg#view-icon-list';

                    
                        var addCacheBust = typeof document !== 'undefined' && document.readyState === 'complete';
    
                        if (addCacheBust) {
                            symbolUrl = 'sprite.svg?icon-list#icon-list';
                            viewUrl = 'sprite.svg?icon-list#view-icon-list';
                        }
                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 18 18',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };